const apiUtils = {
    accuWeather: {
        apiKey: 'GWUSXp7kc1LdAxnO0qG1OJ6Jqdznb08j'
    },
    ipfind: {
        apiKey: '2ab4a8cd-7852-43eb-bc79-f1fd5c13864f'
    }
};

export default apiUtils;